import axios from 'axios';

import { API_URL } from '../config';

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Authorization': `Bearer ${localStorage.getItem('token')}`,
    'Content-Type': 'application/json',
  }
});

export interface Attendance {
  id: number;
  user_id: number;
  check_in: string;
  check_out: string | null;
  duration_seconds: number | null;
  created_at: string;
  updated_at: string;
}

export interface DayAttendance {
  date: string;
  day_name: string;
  records: Attendance[];
  total_duration_seconds: number;
  total_records: number;
}

export interface EmployeeAttendanceInfo {
  user: {
    id: number;
    name: string;
    email: string;
    employee: {
      id: number;
      name: string;
      surname: string;
      email: string;
      phone?: string;
      imageUrl?: string;
    };
  };
  attendances: Record<string, DayAttendance>;
  total_duration_seconds: number;
  total_records: number;
  total_days: number;
  month: string;
  year: number;
  month_number: number;
  vacations: {
    id: number;
    employee_id: number;
    start_date: string;
    end_date: string;
    status: string;
    type: string;
    reason: string;
    created_at: string;
    updated_at: string;
  }[];
}

export interface Location {
  id: number;
  attendance_id: number;
  latitude: number;
  longitude: number;
  created_at: string;
  updated_at: string;
  address: string;
}

export interface AttendanceLocations {
  attendance: Attendance;
  locations: Location[];
  total_locations: number;
}

export const attendanceService = {
  getEmployeeAttendanceInfo: async (employeeId: number, year?: string, month?: string): Promise<EmployeeAttendanceInfo> => {
    let url = `/admin/attendances/employee-infos/${employeeId}`;
    if (year) {
      url += `/${year}`;
      if (month) {
        url += `/${month}`;
      }
    }
    const response = await api.get(url);
    return response.data;
  },

  getAttendanceLocations: async (attendanceId: number): Promise<AttendanceLocations> => {
    const response = await api.get(`/admin/attendances/${attendanceId}/locations`);
    return response.data;
  },

  closeAttendance: async (attendanceId: number, checkOut: string, notes?: string): Promise<Attendance> => {
    const response = await api.post(`/admin/attendances/${attendanceId}/close`, {
      check_out: checkOut,
      notes
    });
    return response.data.attendance;
  },

  deleteAttendance: async (attendanceId: number): Promise<{ message: string }> => {
    const response = await api.delete(`/admin/attendances/${attendanceId}`);
    return response.data;
  },

  storeAttendance: async (userId: number, checkIn: string, checkOut: string, projectId: number): Promise<Attendance> => {
    const response = await api.post('/admin/attendances/store', {
      user_id: userId,
      check_in: checkIn,
      check_out: checkOut,
      project_id: projectId
    });
    return response.data;
  }
}; 